import React from 'react';
import { CSSObject, FlattenSimpleInterpolation } from 'styled-components';

import { IOverlayProps, Overlay } from '@r1-frontend/ui-react/components/overlay';
import { Close } from '@r1-frontend/ui-react/components/svg/main';

import * as ST from './styled';

type TCustomStyle = FlattenSimpleInterpolation | CSSObject

export type TAdaptiveStyles = Partial<{
    default: TCustomStyle,
    mobile: TCustomStyle,
}>;

export interface IDefaultPopupCustomStyles {
    popup: TAdaptiveStyles,
    closePopup?: TAdaptiveStyles,
}

export interface IDefaultPopup extends IOverlayProps {
    isOpen: boolean,
    width?: string,
    height?: string,
    fullWidth?: boolean,
    color?: string,
    backgroundColor?: string,
    closeColor?: string,
    isShowClose?: boolean,
    customStyles?: IDefaultPopupCustomStyles,
    className?: string,

    [key: string]: unknown,
}

const DefaultPopup = ({
    width,
    height,
    isShowClose = true,
    isOpen,
    children,
    fullWidth,
    fullHeight,
    className,
    customStyles,
    onClose,
    align,
    justify,
    $zIndex,
    ...rest
}: IDefaultPopup) => {
    return (
        <Overlay
            $zIndex={$zIndex}
            align={align}
            justify={justify}
            isOpen={isOpen}
            fullWidth={fullWidth}
            fullHeight={fullHeight}
            onClose={onClose}
        >
            <ST.Popup
                width={width}
                height={height}
                fullWidth={fullWidth}
                className={className}
                customStyles={customStyles?.popup}
                {...rest}
            >
                {isShowClose &&
                    <ST.ClosePopup
                        bType={'secondary'}
                        size={'small'}
                        rounded
                        Icon={<Close />}
                        onClick={onClose}
                        customStyles={customStyles?.closePopup}
                    />
                }
                {children}
            </ST.Popup>
        </Overlay>
    );
};

export default DefaultPopup;
